import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import Lightbox from 'react-images'
import styled from 'styled-components'
import { Flex } from '../styles/styled-common'
import { withoutProps } from '../utils'

const Caption = styled.div`
  color: ${p => p.theme.textOffwhite};
  font-size: 0.7em;
  padding: 2px 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const A = styled.a`
  margin: 20px 10px 0;
  border-radius: 5px;
  box-shadow: 2px 2px 4px 1px #000;
  overflow: hidden;
`
export default class Gallery extends PureComponent {
  static displayName = 'Gallery'

  static propTypes = {
    images: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        thumbnail: PropTypes.string.isRequired,
        srcset: PropTypes.array,
        caption: PropTypes.string,
      })
    ).isRequired,
    previewCount: PropTypes.number,
    showCaption: PropTypes.bool,
    justify: PropTypes.string,
  }

  constructor() {
    super()

    this.state = {
      lightboxIsOpen: false,
      currentImage: 0,
    }
  }

  openLightbox = (index, event) => {
    event.preventDefault()
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
    })
  }

  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    })
  }

  gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage - 1,
    })
  }

  gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1,
    })
  }
  gotoImage = index => {
    this.setState({
      currentImage: index,
    })
  }

  handleClickImage = () => {
    if (this.state.currentImage === this.props.images.length - 1) return

    this.gotoNext()
  }
  renderGallery = () => {
    const { images, previewCount, showCaption, justify = 'start' } = this.props

    if (!images || !images.length) return

    const previewImages = images.slice(0, previewCount || images.length)

    return (
      <Flex style={{ margin: '-10px' }} justifyContent={justify}>
        {previewImages.map((image, i) => (
          <A href={image.src} key={i} onClick={e => this.openLightbox(i, e)}>
            <img src={image.thumbnail} alt={image.caption} />
            {showCaption === false || <Caption>{image.caption}</Caption>}
          </A>
        ))}
      </Flex>
    )
  }

  render() {
    return (
      <div {...withoutProps(this.props, Gallery.propTypes)}>
        {this.props.heading && <h2>{this.props.heading}</h2>}
        {this.props.subheading && <p>{this.props.subheading}</p>}
        {this.renderGallery()}
        <Lightbox
          currentImage={this.state.currentImage}
          images={this.props.images}
          isOpen={this.state.lightboxIsOpen}
          onClickImage={this.handleClickImage}
          onClickNext={this.gotoNext}
          onClickPrev={this.gotoPrevious}
          onClickThumbnail={this.gotoImage}
          onClose={this.closeLightbox}
          preventScroll={this.props.preventScroll}
          showThumbnails={this.props.showThumbnails}
          spinner={this.props.spinner}
          spinnerColor={this.props.spinnerColor}
          spinnerSize={this.props.spinnerSize}
          theme={this.props.theme}
          backdropClosesModal
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Gallery.jsx